<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">我的会员</div>
      <div class="search-wrap">
        <div class="search-form">
          <div class="search-item search-input-item">
            <input type="text" class="search-input"  v-model="searchForm.nickName" placeholder="会员昵称"/>
          </div>
          <div class="search-item search-input-item">
            <input type="text" class="search-input"   v-model="searchForm.parentSourceId" placeholder="推荐人ID"/>
          </div>
          <div class="search-item search-input-item">
            <input type="text" class="search-input"  v-model="searchForm.sourceId" placeholder="会员ID"/>
          </div>
          <div class="search-item search-input-item search-box">
            <input type="text" class="search-input"   v-model="searchForm.orderCountMix" placeholder="下单次数"/>
            <span>至</span>
            <input type="text" class="search-input"   v-model="searchForm.orderCountMax" placeholder="下单次数"/>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.createStartTime" @blur.native @focus="showDatePicker('createStartTime')" placeholder="注册日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createStartTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createStartTime')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.createEndTime" @blur.native @focus="showDatePicker('createEndTime')" placeholder="注册日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createEndTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createEndTime')">
            </el-col>
          </div>
          <div class="search-item search-box" v-if="!isBasic">
            <span>是否为总监：</span>
            <RadioGroup v-model="searchForm.isMajor">
              <Radio label="">
                <span>不限</span>
              </Radio>
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="search-btn" @click="handleFilter">查询</div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-0-15 padding-b-8">
      <div class="title-text-official padding-11-0 padding-b-19">列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="ID" width="50" align="center">
            <template slot-scope="{row}">
              <span>{{ row.sourceId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="微信名" width="100" align="left" header-align="center">
            <template slot-scope="{row}">
              <span><img :src="row.headPic" style="width: 22px" />{{ row.nickName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="推荐人ID" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.parentSourceId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="下单次数" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.orderCount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="注册时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="最后下单时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.lastOrderTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" width="100" fixed="right" align="center">
            <template slot-scope="{row}">
              <span class="color-ff4" style="cursor: pointer" v-if="!isBasic"  @click="showDetail(row)">查看详细资料</span>
              <span class="color-ff4" style="cursor: pointer" @click="toOrder(row)">查看订单</span>
              <span class="color-ff4" style="cursor: pointer" v-if="!isBasic && row.isMajor == 0" @click="setDirector(row)">设为总监</span>
              <span class="color-ff4" style="cursor: pointer" v-if="!isBasic && row.isMajor == 1" @click="cancelDirector(row)">取消总监</span>
              <span class="color-ff4" style="cursor: pointer"  @click="createQrcode(row)">生成二维码</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pagesize" @pagination="getList(false)" />
      </div>
    </div>
    <SetDirector ref="SetDirector" @refresh="getList(true)"></SetDirector>
    <CancelDirector ref="CancelDirector" @refresh="getList(true)"></CancelDirector>
    <CreateQrcode ref="CreateQrcode"></CreateQrcode>
    <Detail ref="Detail"></Detail>
    <DatePicker ref="DatePicker" :title="curDateTitle" @selectedDate="selectedDate"></DatePicker>
  </div>
</template>

<script>

import { RadioGroup, Radio } from 'view-design'
import { getPlatformUuid, getIsBasic } from '@/utils/auth'
import { numFormatter } from '@/utils/date'
import { getDate } from '@/utils/date'
import DatePicker from '@/components/h5/DatePicker'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import SetDirector from '@/views/h5/official/member/modal/SetDirector.vue'
import CancelDirector from '@/views/h5/official/member/modal/CancelDirector.vue'
import CreateQrcode from '@/views/h5/official/member/modal/CreateQrcode.vue'
import Detail from '@/views/h5/official/member/modal/Detail.vue'
import member from '@/javaApi/member'
const memberModel = new member()
export default {
  name: 'Member',
  components: {
    Pagination,
    DatePicker,
    RadioGroup,
    Radio,
    SetDirector,
    CancelDirector,
    CreateQrcode,
    Detail

  },
  data: function () {
    return {
      listLoading: false,
      list:[
      ],
      total:0,
      searchForm: {
        page: 1,
        pagesize: 10,
        nickName: undefined,
        phone:undefined,
        parentSourceId:undefined,
        sourceId:undefined,
        start_num:undefined,
        end_num:undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        orderCountMix: undefined,
        orderCountMax: undefined,
        isMajor:undefined,
        sort: '-id'
      },
      platformUuid: getPlatformUuid(),
      isBasic: getIsBasic() === 'true' ? true : false,
      curDateTitle: '',// 日期选择器弹窗标题
      datePicker: '', // 用于判断哪个选择器
    }
  },
  created() {
    this.getList(true)
  },
  computed:{
  },
  methods: {
    getList(first = false){
      if(first === true){
        this.searchForm.page = 1
      }
      let userParam = {
        pageNo:this.searchForm.page,
        pageSize:this.searchForm.pagesize,
        phone: this.searchForm.phone,
        parentSourceId: numFormatter(this.searchForm.parentSourceId),
        orderCountMix:numFormatter(this.searchForm.orderCountMix),
        orderCountMax: numFormatter(this.searchForm.orderCountMax),
        sourceId:numFormatter(this.searchForm.sourceId),
        nickName:this.searchForm.nickName,
        createStartTime:getDate(this.searchForm.createStartTime),
        createEndTime: getDate(this.searchForm.createEndTime),
        isMajor:this.searchForm.isMajor
      }
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        userParam.platformUuid =  this.platformUuid
      }
      if(userParam.createStartTime){
        userParam.createStartTime = userParam.createStartTime+' 00:00:00'
      }else{
        delete userParam.createStartTime
      }
      if(userParam.createEndTime){
        userParam.createEndTime = userParam.createEndTime+' 23:59:59'
      }else{
        delete userParam.createEndTime
      }
      userParam = this.formateInit(userParam)
      memberModel.getUserList(userParam).then(response=>{
        console.log(response)
        let res = response.data
        if(res.code === 200){
          that.listLoading = false
          that.list = res.data?res.data.list:[]
          that.list = that.formateData(that.list)
          that.total = res.data.total
          that.searchForm.pagesize = res.data.pageSize
        }else{
          that.listLoading = false
          let message = res.message?res.message:'系统繁忙请稍后再试！'
          this.$message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }

      })

    },
    formateData(data){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.page
      let pageSize = this.searchForm.pagesize
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    handleFilter(){
      this.getList(true)
    },
    changePage(value){
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value){
      this.searchForm.pagesize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchForm.page == 1){
        this.getList()
      }
    },
    //查看订单
    toOrder(row){
      this.$store.dispatch('h_nav/changeOfficialActiveIndex','3')
      this.$router.push({ path: '/h5/official/order', query: { nick_name:row.nickName }})
    },
    //设为总监
    setDirector(row){
      let param = {
        uuid: row.uuid
      }
      memberModel.userQueryJunior(param).then(response=>{
        let res = response.data
        if(res.code == 200){
          // 1 ：用户无推荐人 2：用户有推荐人但无下级 3：用户有推荐人且有下级
          if(res.data == 3){
            row.isHasNextLevel = 1
          }
          this.$refs.SetDirector.init(true,row)
        }else{
          let message = res.message?res.message:'系统繁忙请稍后再试！'
          this.$message.error(message)
        }
      }).catch(error=>{
        this.$message.error('系统繁忙请稍后再试')
      })
    },
    //取消总监
    cancelDirector(row){
      this.$refs.CancelDirector.init(true,row)
    },
    //查看详细资料
    showDetail(row){
      this.$refs.Detail.init(true,row)
    },
    //生成二维码
    createQrcode(row){
      this.$refs.CreateQrcode.init(true,row)
    },
    showDatePicker(datePicker){
      let title = '请选择开始日期';
      if(datePicker.toUpperCase().indexOf('END') > -1){
        title = '请选择结束日期';
      }
      this.curDateTitle = title
      this.datePicker = datePicker
      this.$refs.DatePicker.init();
    },
    selectedDate(timer){
      this.searchForm[this.datePicker] = timer;
    },
    //清除文本框
    clear(val) {
      if(val.indexOf(".") > -1){
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      }else{
        this[val] = ''
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .table-wrapper {
    width: 100%;
    .color-ff4{
      white-space: nowrap;
      line-height: 2.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/member/Index.vue